import {SELECT_TOOL, ToolMenuActionTypes} from "./types";
import {Tool} from "../../model/tool/tool";

export function selectTool(tool: Tool): ToolMenuActionTypes {
    return {
        type: SELECT_TOOL,
        tool: tool,
    }
}
